import React, { useState, useEffect } from 'react'
import { browserHistory } from 'react-router';
import AssignmentDetailModal from './AssignmentMatrix/Modal/AssignmentDetailModal';
import { AppProperties } from '../common/function';
import ApiRequestService from '../component/ApiRequestService';

import { DEFAULT_END_SPLASH_SCREEN_TEXT } from '../pages/AssignmentMatrix/Constants';

function QuizCreation(props) {
    const appProperties = AppProperties();
    const [assignment, setAssignment] = useState(null);
    const [showAssignmentDetailModal, setShowAssignmentDetailModal] = useState(false);

    useEffect(() => {
        getQuizDetail();
    }, [])

    const goBack = () => {
        const query = props.location?.query || {};
        const baseFolder = appProperties.baseFolder;
        const subsection = query.subsection === "true"; // assuming this was in state
        const is_lti_enabled = query.is_lti_enabled;    // from query (since state not shown)

        if (query.course_indx !== null && query.course_indx !== undefined) {
            // Came from Course/Section Dashboard
            if (query.section_name !== undefined && query.section_name !== null) {
                console.log("sectionsDashboard");
                // Section Dashboard
                browserHistory.push(
                    `${baseFolder}sectionsDashboard?section_id=${query.section_id}` +
                    `&course_id=${query.course_id}` +
                    `&course_name=${query.course_name}` +
                    `&section_name=${query.section_name}` +
                    `&course_indx=${query.course_indx}` +
                    `&semester_id=${query.semester_id}` +
                    `&semester_name=${query.semester_name}` +
                    `&is_current_semester=${query.is_current_semester}`
                );
            } else {
                // Courses Dashboard
                browserHistory.push(
                    `${baseFolder}CoursesDashboard?course_indx=${query.course_indx}` +
                    `&semester_id=${query.semester_id}` +
                    `&semester_name=${query.semester_name}` +
                    `&is_current_semester=${query.is_current_semester}`
                );
            }
        } else if (subsection) {
            browserHistory.push(
                `${baseFolder}subSectionTabs?subsection_id=${query.subsection_id}` +
                `&subsection_name=${query.subsection_name}` +
                `&section_id=${query.section_id}` +
                `&section_name=${query.section_name}` +
                `&course_id=${query.course_id}` +
                `&course_name=${query.course_name}` +
                `&semester_id=${query.semester_id}` +
                `&semester_name=${query.semester_name}` +
                `&is_current_semester=${query.is_current_semester}`
            );
        } else {
            browserHistory.push(
                `${baseFolder}quizList?section_id=${query.section_id}` +
                `&course_id=${query.course_id}` +
                `&course_name=${query.course_name}` +
                `&section_name=${query.section_name}` +
                `&is_lti_enabled=${is_lti_enabled}` +
                `&semester_id=${query.semester_id}` +
                `&semester_name=${query.semester_name}` +
                `&is_current_semester=${query.is_current_semester}`
            );
        }
    };

    const getQuizDetail = (assign) => {
        let payload = {
            course_id: parseInt(props.location.query.course_id, 10),
            section_id: parseInt(props.location.query.section_id, 10),
            quiz_id: parseInt(props.location.query.quiz_id, 10),
        }
        ApiRequestService({
            method: 'post',
            url: '/getQuizById',
            data: payload
        }).then(res => {
            if (res.data.data !== null && res.data.data !== undefined && res.data.data.quiz_id) {
                setAssignment(res.data.data);
            }
            setShowAssignmentDetailModal(true);
        })
    }

    return (
        <div>
            {showAssignmentDetailModal ?
                <AssignmentDetailModal
                    isNewAssignment={false}
                    showModal={showAssignmentDetailModal}
                    assignment={assignment}
                    handleClose={() => {
                        setShowAssignmentDetailModal(false);
                        goBack();
                        // onQuizEditClose();
                    }}
                    onSaveAssignment={(data) => {
                        // onSaveAssignment(data);
                        // setShowAssignmentDetailModal(false);
                    }}
                    course_id={parseInt(props.location.query.course_id)}
                    handleResetPreview={null}
                    onAfterPreviewClick={() => { }}
                />
                : null}
        </div>
    )
}

export default QuizCreation;
